(function () {
  function onReady(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback);
      return;
    }

    callback();
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function initHeroSlider() {
    var root = document.querySelector("[data-hero-slider]");
    if (!root) return;

    var slides = Array.prototype.slice.call(root.querySelectorAll("[data-hero-slide]"));
    var dots = Array.prototype.slice.call(root.querySelectorAll("[data-hero-dot]"));
    var prevButton = root.querySelector("[data-hero-prev]");
    var nextButton = root.querySelector("[data-hero-next]");

    if (slides.length <= 1) return;

    var currentIndex = 0;
    var timerId = null;
    var transitioning = false;

    function render(nextIndex) {
      currentIndex = (nextIndex + slides.length) % slides.length;

      slides.forEach(function (slide, index) {
        var isActive = index === currentIndex;
        slide.hidden = !isActive;
        slide.classList.toggle("is-active", isActive);
        slide.setAttribute("aria-hidden", isActive ? "false" : "true");
      });

      dots.forEach(function (dot, index) {
        var isActive = index === currentIndex;
        dot.classList.toggle("is-active", isActive);
        dot.setAttribute("aria-current", isActive ? "true" : "false");
      });

      window.setTimeout(function () {
        transitioning = false;
      }, 600);
    }

    function goTo(nextIndex) {
      if (transitioning) return;
      transitioning = true;
      render(nextIndex);
    }

    function stopAutoplay() {
      if (timerId !== null) {
        window.clearInterval(timerId);
        timerId = null;
      }
      // Ferma anche la barra di avanzamento sul puntino attivo (bn-home.css)
      root.classList.add("is-paused");
    }

    function startAutoplay() {
      stopAutoplay();
      root.classList.remove("is-paused");
      timerId = window.setInterval(function () {
        goTo(currentIndex + 1);
      }, 6000);
    }

    if (prevButton) {
      prevButton.addEventListener("click", function () {
        goTo(currentIndex - 1);
        startAutoplay();
      });
    }

    if (nextButton) {
      nextButton.addEventListener("click", function () {
        goTo(currentIndex + 1);
        startAutoplay();
      });
    }

    dots.forEach(function (dot, index) {
      dot.addEventListener("click", function () {
        goTo(index);
        startAutoplay();
      });
    });

    root.addEventListener("mouseenter", stopAutoplay);
    root.addEventListener("mouseleave", startAutoplay);
    root.addEventListener("focusin", stopAutoplay);
    root.addEventListener("focusout", startAutoplay);

    render(0);
    startAutoplay();
  }

  function initShowcaseBottleMotion() {
    if (!window.requestAnimationFrame) return;

    var motionQuery = window.matchMedia ? window.matchMedia("(prefers-reduced-motion: reduce)") : null;
    if (motionQuery && motionQuery.matches) return;

    var shells = Array.prototype.slice.call(document.querySelectorAll(".bn-showcase .bn-media-shell--showcase"));
    if (shells.length === 0) return;

    var items = shells.map(function (shell, index) {
      var showcaseItem = shell.closest(".bn-showcase__item");
      var button = showcaseItem ? showcaseItem.querySelector("[data-showcase-motion-button]") : null;
      var direction = showcaseItem && showcaseItem.classList.contains("bn-showcase__item--reversed") ? -1 : 1;

      return {
        button: button,
        currentButtonScale: 1,
        currentButtonX: 0,
        currentButtonY: 0,
        currentRotate: 0,
        currentX: 0,
        currentY: 0,
        direction: direction,
        element: shell,
        phase: index * 1.37,
        targetButtonScale: 1,
        targetButtonX: 0,
        targetButtonY: 0,
        targetRotate: 0,
        targetX: 0,
        targetY: 0
      };
    });

    var frameId = null;
    var lastScrollY = window.scrollY || window.pageYOffset || 0;
    var scrollVelocity = 0;

    function scheduleRender() {
      if (frameId !== null) return;
      frameId = window.requestAnimationFrame(renderFrame);
    }

    function updateTargets() {
      var scrollY = window.scrollY || window.pageYOffset || 0;
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
      var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 1;
      var bottleMotionScale = viewportWidth < 750 ? 0.05 : 0.1;
      var buttonMotionScale = viewportWidth < 750 ? 0.9 : 1.25;

      items.forEach(function (item) {
        var rect = item.element.getBoundingClientRect();
        var centerOffset = (rect.top + rect.height / 2 - viewportHeight / 2) / (viewportHeight / 2);
        var visibility = clamp(1 - Math.abs(centerOffset) * 1.15, 0, 1);

        if (rect.bottom < -viewportHeight * 0.18 || rect.top > viewportHeight * 1.18) {
          visibility = 0;
        }

        var baseRotate =
          clamp(centerOffset * item.direction * 3.8 * bottleMotionScale, -3.8 * bottleMotionScale, 3.8 * bottleMotionScale) *
          visibility;
        var velocityTilt =
          clamp(scrollVelocity * item.direction * -0.2 * bottleMotionScale, -2 * bottleMotionScale, 2 * bottleMotionScale) *
          visibility;
        var tremor =
          Math.sin(scrollY * 0.068 + item.phase) *
          Math.min(Math.abs(scrollVelocity) * 0.22, 2.2) *
          visibility *
          bottleMotionScale;

        item.targetRotate = baseRotate + velocityTilt + tremor;
        item.targetX =
          clamp(centerOffset * item.direction * -13 * bottleMotionScale, -13 * bottleMotionScale, 13 * bottleMotionScale) *
            visibility +
          tremor * 3.2;
        item.targetY =
          (Math.abs(baseRotate) * -0.8 - Math.min(Math.abs(scrollVelocity) * 0.34, 3.4) * visibility) * bottleMotionScale;

        var buttonBaseX =
          clamp(centerOffset * item.direction * -6.5 * buttonMotionScale, -6.5 * buttonMotionScale, 6.5 * buttonMotionScale) *
          visibility;
        var buttonVelocityX =
          clamp(scrollVelocity * item.direction * -0.18 * buttonMotionScale, -4.5 * buttonMotionScale, 4.5 * buttonMotionScale) *
          visibility;
        var buttonLiftY =
          clamp(-Math.abs(scrollVelocity) * 0.3 * buttonMotionScale, -5.5 * buttonMotionScale, 0) * visibility;
        var buttonScaleBoost = 1 + Math.min(Math.abs(scrollVelocity) * 0.0065, 0.035) * visibility;

        item.targetButtonX = buttonBaseX + buttonVelocityX;
        item.targetButtonY = buttonLiftY;
        item.targetButtonScale = buttonScaleBoost;
      });
    }

    function renderFrame() {
      frameId = null;
      updateTargets();

      var shouldContinue = false;

      items.forEach(function (item) {
        item.currentRotate += (item.targetRotate - item.currentRotate) * 0.27;
        item.currentX += (item.targetX - item.currentX) * 0.27;
        item.currentY += (item.targetY - item.currentY) * 0.27;

        item.element.style.setProperty("--bn-showcase-rotate", item.currentRotate.toFixed(3) + "deg");
        item.element.style.setProperty("--bn-showcase-shift-x", item.currentX.toFixed(3) + "px");
        item.element.style.setProperty("--bn-showcase-shift-y", item.currentY.toFixed(3) + "px");

        if (item.button) {
          item.currentButtonScale += (item.targetButtonScale - item.currentButtonScale) * 0.22;
          item.currentButtonX += (item.targetButtonX - item.currentButtonX) * 0.22;
          item.currentButtonY += (item.targetButtonY - item.currentButtonY) * 0.22;

          item.button.style.setProperty("--bn-showcase-button-scale", item.currentButtonScale.toFixed(4));
          item.button.style.setProperty("--bn-showcase-button-shift-x", item.currentButtonX.toFixed(3) + "px");
          item.button.style.setProperty("--bn-showcase-button-shift-y", item.currentButtonY.toFixed(3) + "px");
        }

        if (
          Math.abs(item.targetRotate - item.currentRotate) > 0.01 ||
          Math.abs(item.targetX - item.currentX) > 0.01 ||
          Math.abs(item.targetY - item.currentY) > 0.01 ||
          Math.abs(item.targetButtonScale - item.currentButtonScale) > 0.001 ||
          Math.abs(item.targetButtonX - item.currentButtonX) > 0.01 ||
          Math.abs(item.targetButtonY - item.currentButtonY) > 0.01
        ) {
          shouldContinue = true;
        }
      });

      scrollVelocity *= 0.8;

      if (Math.abs(scrollVelocity) > 0.04) {
        shouldContinue = true;
      }

      if (shouldContinue) {
        scheduleRender();
      }
    }

    function handleScroll() {
      var currentScrollY = window.scrollY || window.pageYOffset || 0;
      var deltaY = currentScrollY - lastScrollY;

      lastScrollY = currentScrollY;
      scrollVelocity = clamp(scrollVelocity * 0.45 + deltaY * 1.35, -22, 22);

      scheduleRender();
    }

    function handleResize() {
      scheduleRender();
    }

    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleResize);

    scheduleRender();
  }

  function initLocationMapParallax() {
    if (!window.requestAnimationFrame) return;

    var motionQuery = window.matchMedia ? window.matchMedia("(prefers-reduced-motion: reduce)") : null;
    if (motionQuery && motionQuery.matches) return;

    var mapCard = document.querySelector("[data-location-map-card]");
    var mapMedia = document.querySelector("[data-location-map-media]");
    if (!mapCard || !mapMedia) return;

    var frameId = null;

    function scheduleRender() {
      if (frameId !== null) return;
      frameId = window.requestAnimationFrame(renderFrame);
    }

    function renderFrame() {
      frameId = null;

      var rect = mapCard.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
      var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 1;
      var progress = (rect.top + rect.height / 2 - viewportHeight / 2) / (viewportHeight / 2);
      var visibility = clamp(1 - Math.abs(progress) * 1.12, 0, 1);
      var maxShiftY = viewportWidth < 750 ? 26 : 58;
      var maxShiftX = viewportWidth < 750 ? 14 : 30;
      var shiftY = clamp(progress * -maxShiftY, -maxShiftY, maxShiftY) * visibility;
      var shiftX = clamp(progress * maxShiftX, -maxShiftX, maxShiftX) * visibility;

      if (rect.bottom < -viewportHeight * 0.18 || rect.top > viewportHeight * 1.18) {
        shiftX = 0;
        shiftY = 0;
      }

      mapCard.style.setProperty("--bn-location-map-parallax-x", shiftX.toFixed(3) + "px");
      mapCard.style.setProperty("--bn-location-map-parallax-y", shiftY.toFixed(3) + "px");
    }

    function handleScroll() {
      scheduleRender();
    }

    function handleResize() {
      scheduleRender();
    }

    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleResize);

    scheduleRender();
  }

  function initLocationVideoMedia(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var videos = Array.prototype.slice.call(scope.querySelectorAll("[data-location-video]"));
    var embeds = Array.prototype.slice.call(scope.querySelectorAll("[data-location-video-embed]"));

    videos.forEach(function (video) {
      var source = video.querySelector("source");
      var videoSrc = video.getAttribute("data-location-video-src") || (source && source.getAttribute("src")) || "";

      if (videoSrc && video.dataset.locationVideoLoadedSrc !== videoSrc) {
        video.dataset.locationVideoLoadedSrc = videoSrc;
        video.setAttribute("src", videoSrc);
        video.load();
      }

      function enforcePlayback() {
        video.autoplay = true;
        video.controls = false;
        video.defaultMuted = true;
        video.loop = true;
        video.muted = true;
        video.playsInline = true;
        video.volume = 0;
        video.removeAttribute("controls");
        video.setAttribute("autoplay", "autoplay");
        video.setAttribute("muted", "muted");
        video.setAttribute("loop", "loop");
        video.setAttribute("playsinline", "playsinline");
        video.setAttribute("webkit-playsinline", "webkit-playsinline");

        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(function () {});
        }
      }

      if (video.dataset.locationVideoInitialized !== "true") {
        video.dataset.locationVideoInitialized = "true";
        video.addEventListener("loadedmetadata", enforcePlayback);
        video.addEventListener("canplay", enforcePlayback);
        video.addEventListener("playing", function () {
          video.removeAttribute("controls");
        });
      }

      enforcePlayback();
    });

    embeds.forEach(function (iframe) {
      var embedSrc = iframe.getAttribute("data-location-video-src") || iframe.getAttribute("src") || "";

      function playEmbed() {
        if (!iframe.contentWindow) return;

        if (iframe.dataset.videoType === "youtube") {
          iframe.contentWindow.postMessage(
            JSON.stringify({
              event: "command",
              func: "mute",
              args: []
            }),
            "*"
          );
          iframe.contentWindow.postMessage(
            JSON.stringify({
              event: "command",
              func: "playVideo",
              args: []
            }),
            "*"
          );
          return;
        }

        if (iframe.dataset.videoType === "vimeo") {
          iframe.contentWindow.postMessage({ method: "setVolume", value: 0 }, "*");
          iframe.contentWindow.postMessage({ method: "play" }, "*");
        }
      }

      if (iframe.dataset.locationVideoInitialized !== "true") {
        iframe.dataset.locationVideoInitialized = "true";
        iframe.addEventListener("load", function () {
          window.setTimeout(playEmbed, 120);
        });
      }

      if (embedSrc && iframe.dataset.locationVideoLoadedSrc !== embedSrc) {
        iframe.dataset.locationVideoLoadedSrc = embedSrc;
        iframe.setAttribute("src", embedSrc);
      }

      window.setTimeout(playEmbed, 180);
    });
  }

  /*
    Nastro d'olio della hero: una curva (Catmull-Rom) che passa dietro la bottiglia,
    le gira davanti in basso e risale a destra. Ogni punto ha una profondità z:
    i tratti con z < 0 vanno sul canvas dietro, gli altri su quello davanti.
    Il volume lucido si ottiene sovrapponendo strisce sempre più strette e chiare,
    con il riflesso che scivola da un lato all'altro mentre il nastro si "attorciglia".
  */
  var OIL_PALETTES = {
    olive: {
      edge: "#34500a",
      body: ["#5c8212", "#8ab51f", "#cde35c"],
      spec: "rgba(255, 255, 230, 0.9)",
      glow: "rgba(150, 195, 40, 0.38)"
    },
    citrus: {
      edge: "#963d04",
      body: ["#cf640c", "#f3931d", "#ffd66b"],
      spec: "rgba(255, 250, 225, 0.9)",
      glow: "rgba(255, 160, 40, 0.38)"
    }
  };

  // x, y (frazioni del canvas), z (dietro -1 / davanti +1), spessore (frazione della larghezza)
  var OIL_PATH = [
    [0.8, 0.2, -1, 0],
    [0.62, 0.08, -1, 0.05],
    [0.36, 0.1, -1, 0.09],
    [0.17, 0.28, -1, 0.12],
    [0.1, 0.5, -1, 0.14],
    [0.16, 0.72, -1, 0.13],
    [0.3, 0.86, -0.2, 0.11],
    [0.5, 0.93, 1, 0.1],
    [0.7, 0.88, 1, 0.09],
    [0.84, 0.74, -0.6, 0.08],
    [0.88, 0.56, -1, 0.06],
    [0.84, 0.42, -1, 0.03],
    [0.92, 0.34, -1, 0]
  ];

  var OIL_LAYERS = [
    // larghezza relativa, spostamento verso la luce, indice colore (-1 = bordo, 3 = riflesso)
    [1, 0, -1],
    [0.84, -0.08, 0],
    [0.6, -0.2, 1],
    [0.32, -0.36, 2],
    [0.09, -0.52, 3]
  ];

  function initOilRibbon() {
    var wrappers = Array.prototype.slice.call(document.querySelectorAll('[data-oil-effect="ribbon"]'));
    if (!wrappers.length) return;

    var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var samplesCount = 140;
    var heroVisible = true;
    var frameId = null;
    var lastTime = 0;
    var clock = reduceMotion ? 2 : 0;

    var ribbons = wrappers.map(function (wrapper) {
      var back = wrapper.querySelector(".bn-oil--back");
      var front = wrapper.querySelector(".bn-oil--front");
      if (!back || !front) return null;
      wrapper.classList.add("is-oil-ready");

      return {
        wrapper: wrapper,
        slide: wrapper.closest("[data-hero-slide]"),
        palette: OIL_PALETTES[wrapper.getAttribute("data-oil-palette")] || OIL_PALETTES.olive,
        back: back,
        front: front,
        backCtx: back.getContext("2d"),
        frontCtx: front.getContext("2d"),
        width: 0,
        height: 0,
        active: false,
        reveal: 0,
        dirty: true,
        drops: [],
        floaters: createFloaters()
      };
    }).filter(Boolean);

    function createFloaters() {
      var list = [];
      for (var i = 0; i < 9; i++) {
        var angle = (i / 9) * Math.PI * 2 + Math.random() * 0.5;
        list.push({
          x: 0.5 + Math.cos(angle) * (0.32 + Math.random() * 0.12),
          y: 0.5 + Math.sin(angle) * (0.38 + Math.random() * 0.08),
          r: 0.006 + Math.random() * 0.012,
          z: i % 3 === 0 ? 1 : -1,
          phase: Math.random() * Math.PI * 2,
          speed: 0.4 + Math.random() * 0.5
        });
      }
      return list;
    }

    function resize(ribbon) {
      var width = ribbon.back.clientWidth;
      var height = ribbon.back.clientHeight;
      if (width === ribbon.width && height === ribbon.height) return;

      var ratio = Math.min(window.devicePixelRatio || 1, 2);
      [ribbon.back, ribbon.front].forEach(function (canvas) {
        canvas.width = Math.round(width * ratio);
        canvas.height = Math.round(height * ratio);
      });
      ribbon.backCtx.setTransform(ratio, 0, 0, ratio, 0, 0);
      ribbon.frontCtx.setTransform(ratio, 0, 0, ratio, 0, 0);
      ribbon.width = width;
      ribbon.height = height;
      ribbon.dirty = true;
    }

    function catmull(p0, p1, p2, p3, t) {
      var t2 = t * t;
      var t3 = t2 * t;
      return 0.5 * (2 * p1 + (p2 - p0) * t + (2 * p0 - 5 * p1 + 4 * p2 - p3) * t2 + (3 * p1 - p0 - 3 * p2 + p3) * t3);
    }

    function buildSamples(ribbon, time) {
      var width = ribbon.width;
      var height = ribbon.height;
      var last = OIL_PATH.length - 1;
      var points = OIL_PATH.map(function (point, index) {
        // Ogni punto ondeggia per conto suo: il nastro sembra liquido e non rigido
        return [
          (point[0] + Math.sin(time * 0.8 + index * 1.7) * 0.012) * width,
          (point[1] + Math.cos(time * 0.7 + index * 1.1) * 0.012) * height,
          point[2],
          point[3] * width
        ];
      });
      var samples = [];

      for (var i = 0; i <= samplesCount; i++) {
        var u = i / samplesCount;
        var position = u * last;
        var index = Math.min(Math.floor(position), last - 1);
        var t = position - index;
        var p0 = points[Math.max(index - 1, 0)];
        var p1 = points[index];
        var p2 = points[index + 1];
        var p3 = points[Math.min(index + 2, last)];

        samples.push({
          u: u,
          x: catmull(p0[0], p1[0], p2[0], p3[0], t),
          y: catmull(p0[1], p1[1], p2[1], p3[1], t),
          z: p1[2] + (p2[2] - p1[2]) * t,
          w: Math.max(catmull(p0[3], p1[3], p2[3], p3[3], t), 0),
          twist: Math.cos(u * 9 - time * 1.6)
        });
      }

      samples.forEach(function (sample, i) {
        var prev = samples[Math.max(i - 1, 0)];
        var next = samples[Math.min(i + 1, samplesCount)];
        var dx = next.x - prev.x;
        var dy = next.y - prev.y;
        var length = Math.hypot(dx, dy) || 1;
        sample.tx = dx / length;
        sample.ty = dy / length;
        sample.nx = -sample.ty;
        sample.ny = sample.tx;
        // Torsione: il nastro si assottiglia quando "gira di taglio"
        sample.half = (sample.w / 2) * (0.45 + 0.55 * Math.abs(sample.twist));
      });

      return samples;
    }

    function drawRun(ctx, run, palette, isBack) {
      if (run.length < 2) return;

      OIL_LAYERS.forEach(function (layer, layerIndex) {
        ctx.beginPath();
        run.forEach(function (sample, i) {
          var offset = layer[1] * sample.twist * sample.half;
          var reach = layer[0] * sample.half;
          var x = sample.x + sample.nx * (offset + reach);
          var y = sample.y + sample.ny * (offset + reach);
          if (i === 0) ctx.moveTo(x, y);
          else ctx.lineTo(x, y);
        });
        for (var i = run.length - 1; i >= 0; i--) {
          var sample = run[i];
          var offset = layer[1] * sample.twist * sample.half;
          var reach = layer[0] * sample.half;
          ctx.lineTo(sample.x + sample.nx * (offset - reach), sample.y + sample.ny * (offset - reach));
        }
        ctx.closePath();

        var colorIndex = layer[2];
        ctx.fillStyle = colorIndex === -1 ? palette.edge : colorIndex === 3 ? palette.spec : palette.body[colorIndex];
        if (layerIndex === 0) {
          ctx.shadowColor = palette.glow;
          ctx.shadowBlur = 16;
        }
        ctx.fill();
        ctx.shadowBlur = 0;
      });

      // Dietro la bottiglia il nastro è un po' più in ombra
      if (isBack) {
        ctx.beginPath();
        run.forEach(function (sample, i) {
          var x = sample.x + sample.nx * sample.half;
          var y = sample.y + sample.ny * sample.half;
          if (i === 0) ctx.moveTo(x, y);
          else ctx.lineTo(x, y);
        });
        for (var j = run.length - 1; j >= 0; j--) {
          ctx.lineTo(run[j].x - run[j].nx * run[j].half, run[j].y - run[j].ny * run[j].half);
        }
        ctx.closePath();
        ctx.fillStyle = "rgba(0, 0, 0, 0.22)";
        ctx.fill();
      }
    }

    function drawFlow(ctx, run, palette, time) {
      // Filamenti di luce che scorrono lungo il nastro: danno il senso del flusso
      if (run.length < 2) return;
      ctx.save();
      ctx.beginPath();
      run.forEach(function (sample, i) {
        var offset = -0.25 * sample.twist * sample.half;
        var x = sample.x + sample.nx * offset;
        var y = sample.y + sample.ny * offset;
        if (i === 0) ctx.moveTo(x, y);
        else ctx.lineTo(x, y);
      });
      ctx.setLineDash([18, 46]);
      ctx.lineDashOffset = -time * 90;
      ctx.lineCap = "round";
      ctx.lineWidth = 2;
      ctx.strokeStyle = palette.spec;
      ctx.globalAlpha = 0.45;
      ctx.stroke();
      ctx.restore();
    }

    function drawDrop(ctx, x, y, radius, palette, alpha) {
      var gradient = ctx.createRadialGradient(x - radius * 0.3, y - radius * 0.35, radius * 0.1, x, y, radius);
      gradient.addColorStop(0, palette.body[2]);
      gradient.addColorStop(0.5, palette.body[1]);
      gradient.addColorStop(1, palette.edge);
      ctx.globalAlpha = alpha;
      ctx.fillStyle = gradient;
      ctx.beginPath();
      ctx.arc(x, y, radius, 0, Math.PI * 2);
      ctx.fill();
      ctx.fillStyle = palette.spec;
      ctx.beginPath();
      ctx.arc(x - radius * 0.35, y - radius * 0.4, radius * 0.22, 0, Math.PI * 2);
      ctx.fill();
      ctx.globalAlpha = 1;
    }

    function spawnDrops(ribbon, samples, dt) {
      if (reduceMotion || ribbon.drops.length > 40) return;
      var expected = dt * 9;
      while (expected > 0) {
        if (Math.random() < expected) {
          // Più schizzi dalle due punte, qualcuno lungo il nastro
          var roll = Math.random();
          var u = roll < 0.3 ? Math.random() * 0.06 : roll < 0.6 ? 0.9 + Math.random() * 0.1 : 0.1 + Math.random() * 0.8;
          if (u > ribbon.reveal) return;
          var sample = samples[Math.round(u * samplesCount)];
          var side = Math.random() < 0.5 ? -1 : 1;
          var push = (0.08 + Math.random() * 0.25) * ribbon.height;
          var along = (u < 0.5 ? -1 : 1) * (0.05 + Math.random() * 0.15) * ribbon.height;
          ribbon.drops.push({
            x: sample.x + sample.nx * sample.half * side,
            y: sample.y + sample.ny * sample.half * side,
            vx: sample.nx * push * side + sample.tx * along,
            vy: sample.ny * push * side + sample.ty * along - 0.1 * ribbon.height,
            r: (0.004 + Math.random() * 0.01) * ribbon.width,
            z: sample.z,
            age: 0,
            life: 1 + Math.random() * 0.8
          });
        }
        expected -= 1;
      }
    }

    function render(ribbon, dt) {
      resize(ribbon);
      if (!ribbon.width) return;

      var time = clock;
      var samples = buildSamples(ribbon, time);
      var palette = ribbon.palette;
      var backCtx = ribbon.backCtx;
      var frontCtx = ribbon.frontCtx;

      // Ingresso a ogni cambio slide: il nastro "si versa" da un capo all'altro
      if (ribbon.reveal < 1) {
        ribbon.reveal = reduceMotion ? 1 : Math.min(ribbon.reveal + dt / 1.4, 1);
      }
      var head = 1 - Math.pow(1 - ribbon.reveal, 3);

      backCtx.clearRect(0, 0, ribbon.width, ribbon.height);
      frontCtx.clearRect(0, 0, ribbon.width, ribbon.height);

      var visible = samples.filter(function (sample) {
        return sample.u <= head;
      });
      if (head < 1) {
        visible.forEach(function (sample) {
          sample.half *= Math.min((head - sample.u) / 0.06, 1);
        });
      }

      // Divide il nastro in tratti continui dietro/davanti (il punto di passaggio sta in entrambi)
      var runs = [];
      var current = null;
      visible.forEach(function (sample) {
        var isFront = sample.z >= 0;
        if (!current || current.front !== isFront) {
          var previous = current && current.samples[current.samples.length - 1];
          current = { front: isFront, samples: previous ? [previous] : [] };
          runs.push(current);
        }
        current.samples.push(sample);
      });

      runs.forEach(function (run) {
        var ctx = run.front ? frontCtx : backCtx;
        drawRun(ctx, run.samples, palette, !run.front);
        drawFlow(ctx, run.samples, palette, time);
      });

      ribbon.floaters.forEach(function (floater) {
        var ctx = floater.z > 0 ? frontCtx : backCtx;
        var x = (floater.x + Math.sin(time * floater.speed + floater.phase) * 0.02) * ribbon.width;
        var y = (floater.y + Math.cos(time * floater.speed * 0.8 + floater.phase) * 0.025) * ribbon.height;
        drawDrop(ctx, x, y, floater.r * ribbon.width, palette, 0.9 * ribbon.reveal);
      });

      spawnDrops(ribbon, samples, dt);
      ribbon.drops = ribbon.drops.filter(function (drop) {
        drop.age += dt;
        drop.vy += 0.9 * ribbon.height * dt;
        drop.x += drop.vx * dt;
        drop.y += drop.vy * dt;
        var fade = 1 - drop.age / drop.life;
        if (fade <= 0) return false;
        drawDrop(drop.z >= 0 ? frontCtx : backCtx, drop.x, drop.y, drop.r * (0.6 + fade * 0.4), palette, Math.min(fade * 1.5, 1));
        return true;
      });

      ribbon.dirty = false;
    }

    function frame(now) {
      frameId = null;
      var dt = lastTime ? Math.min((now - lastTime) / 1000, 0.05) : 0;
      lastTime = now;
      if (!reduceMotion) clock += dt;

      ribbons.forEach(function (ribbon) {
        var isActive = !ribbon.slide || ribbon.slide.classList.contains("is-active");
        if (isActive && !ribbon.active) {
          ribbon.reveal = 0;
          ribbon.drops = [];
          ribbon.dirty = true;
        }
        ribbon.active = isActive;
        if (!isActive) return;
        if (reduceMotion && !ribbon.dirty && ribbon.width === ribbon.back.clientWidth) return;
        render(ribbon, dt);
      });

      schedule();
    }

    function schedule() {
      if (frameId !== null || !heroVisible || document.hidden) return;
      frameId = window.requestAnimationFrame(frame);
    }

    if ("IntersectionObserver" in window) {
      var hero = wrappers[0].closest("[data-hero-slider]") || wrappers[0];
      new IntersectionObserver(function (entries) {
        heroVisible = entries[0].isIntersecting;
        lastTime = 0;
        schedule();
      }).observe(hero);
    }

    document.addEventListener("visibilitychange", function () {
      lastTime = 0;
      schedule();
    });

    schedule();
  }

  /*
    Oro liquido della hero (WebGL, senza librerie): gocce "metaball" dietro al prodotto
    che salgono e scendono ai lati come in una lava lamp, si fondono in una pozza alla
    base e si separano. Lo shader calcola il campo delle gocce, ne ricava la normale
    (per luce, riflesso e bordo luminoso) e rende l'olio più scuro dove è più spesso.
  */
  var LAVA_PALETTES = {
    olive: { deep: [0.2, 0.26, 0.02], body: [0.52, 0.6, 0.08], light: [0.95, 0.88, 0.42], glow: [0.62, 0.68, 0.14] },
    citrus: { deep: [0.5, 0.18, 0.01], body: [0.9, 0.48, 0.06], light: [1, 0.86, 0.45], glow: [1, 0.6, 0.15] }
  };

  var LAVA_BLOB_COUNT = 12;

  var LAVA_VERTEX = "attribute vec2 aPos; void main() { gl_Position = vec4(aPos, 0.0, 1.0); }";

  var LAVA_FRAGMENT = [
    "precision mediump float;",
    "uniform vec2 uRes;",
    "uniform vec3 uBlobs[" + LAVA_BLOB_COUNT + "];",
    "uniform vec3 uDeep;",
    "uniform vec3 uBody;",
    "uniform vec3 uLight;",
    "uniform vec3 uGlow;",
    "const float T = 0.25;",
    "void main() {",
    "  vec2 p = vec2(gl_FragCoord.x, uRes.y - gl_FragCoord.y) / uRes.y;",
    "  float f = 0.0;",
    "  vec2 g = vec2(0.0);",
    // Nucleo limitato (1 - d²/R²)³: campo e gradiente restano finiti anche al centro delle gocce
    "  for (int i = 0; i < " + LAVA_BLOB_COUNT + "; i++) {",
    "    vec3 b = uBlobs[i];",
    "    vec2 d = p - b.xy;",
    "    float R2 = 4.0 * b.z * b.z + 1e-5;",
    "    float q = 1.0 - dot(d, d) / R2;",
    "    if (q > 0.0) {",
    "      f += q * q * q;",
    "      g += -6.0 * q * q * d / R2;",
    "    }",
    "  }",
    "  float a = smoothstep(T - 0.012, T + 0.012, f);",
    "  vec3 n = normalize(vec3(-g * 0.12, 1.0));",
    "  vec3 L = normalize(vec3(-0.45, -0.55, 0.7));",
    "  float diff = clamp(dot(n, L), 0.0, 1.0);",
    "  float spec = pow(clamp(dot(n, normalize(L + vec3(0.0, 0.0, 1.0))), 0.0, 1.0), 48.0);",
    "  float thick = clamp((f - T) / 0.9, 0.0, 1.0);",
    "  vec3 col = mix(uLight, uBody, smoothstep(0.0, 0.45, thick));",
    "  col = mix(col, uDeep, smoothstep(0.35, 1.0, thick) * 0.75);",
    "  col *= 0.6 + 0.55 * diff;",
    "  col += uLight * pow(1.0 - n.z, 2.0) * 0.8;",
    "  col += vec3(1.0, 1.0, 0.9) * spec;",
    // Olio traslucido: sottile ai bordi, più pieno dove è spesso; riflesso e bordo restano accesi
    "  float rim = pow(1.0 - n.z, 2.0);",
    "  float body = a * clamp(mix(0.55, 0.92, smoothstep(0.0, 0.6, thick)) + spec + rim * 0.4, 0.0, 1.0);",
    "  float glow = pow(smoothstep(0.0, T, f), 2.0) * (1.0 - a) * 0.4;",
    "  gl_FragColor = vec4(col * body + uGlow * glow, body + glow);",
    "}"
  ].join("\n");

  function initOilLava() {
    var wrappers = Array.prototype.slice.call(document.querySelectorAll('[data-oil-effect="lava"]'));
    if (!wrappers.length) return;

    var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var heroVisible = true;
    var frameId = null;
    var lastTime = 0;
    var clock = reduceMotion ? 3 : 0;

    // Posizioni in frazioni del canvas (la bottiglia sta al centro, x 0.4-0.6); raggio in frazioni dell'altezza
    var blobs = [
      { x: 0.22, r: 0.075, speed: 0.32, phase: 0 },
      { x: 0.27, r: 0.06, speed: 0.41, phase: 2.1 },
      { x: 0.17, r: 0.05, speed: 0.27, phase: 4.2 },
      { x: 0.78, r: 0.07, speed: 0.36, phase: 1.1 },
      { x: 0.73, r: 0.055, speed: 0.29, phase: 3.3 },
      { x: 0.83, r: 0.045, speed: 0.44, phase: 5.2 },
      { x: 0.35, r: 0.07, speed: 0.5, phase: 0.6, pool: true },
      { x: 0.5, r: 0.085, speed: 0.4, phase: 2.4, pool: true },
      { x: 0.65, r: 0.07, speed: 0.55, phase: 4.1, pool: true },
      { x: 0.5, r: 0.045, speed: 0.22, phase: 1.7, orbit: true },
      { x: 0.5, r: 0.035, speed: 0.31, phase: 3.9, orbit: true },
      { x: 0.5, r: 0.03, speed: 0.26, phase: 5.6, orbit: true }
    ];
    var blobData = new Float32Array(LAVA_BLOB_COUNT * 3);

    var instances = wrappers.map(function (wrapper) {
      var canvas = wrapper.querySelector(".bn-oil--lava");
      if (!canvas) return null;
      return {
        wrapper: wrapper,
        canvas: canvas,
        slide: wrapper.closest("[data-hero-slider] [data-hero-slide]"),
        palette: LAVA_PALETTES[wrapper.getAttribute("data-oil-palette")] || LAVA_PALETTES.olive,
        gl: null,
        failed: false,
        active: false,
        reveal: 0,
        dirty: true,
        width: 0,
        height: 0
      };
    }).filter(Boolean);

    function compile(gl, type, source) {
      var shader = gl.createShader(type);
      gl.shaderSource(shader, source);
      gl.compileShader(shader);
      return gl.getShaderParameter(shader, gl.COMPILE_STATUS) ? shader : null;
    }

    // Il contesto WebGL si crea solo quando la slide diventa visibile la prima volta
    function setup(instance) {
      var gl = instance.canvas.getContext("webgl", { premultipliedAlpha: true, antialias: false });
      var vertex = gl && compile(gl, gl.VERTEX_SHADER, LAVA_VERTEX);
      var fragment = gl && compile(gl, gl.FRAGMENT_SHADER, LAVA_FRAGMENT);
      if (!vertex || !fragment) {
        instance.failed = true;
        return;
      }

      var program = gl.createProgram();
      gl.attachShader(program, vertex);
      gl.attachShader(program, fragment);
      gl.linkProgram(program);
      if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
        instance.failed = true;
        return;
      }
      gl.useProgram(program);

      var buffer = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
      var position = gl.getAttribLocation(program, "aPos");
      gl.enableVertexAttribArray(position);
      gl.vertexAttribPointer(position, 2, gl.FLOAT, false, 0, 0);

      var palette = instance.palette;
      gl.uniform3fv(gl.getUniformLocation(program, "uDeep"), palette.deep);
      gl.uniform3fv(gl.getUniformLocation(program, "uBody"), palette.body);
      gl.uniform3fv(gl.getUniformLocation(program, "uLight"), palette.light);
      gl.uniform3fv(gl.getUniformLocation(program, "uGlow"), palette.glow);

      instance.gl = gl;
      instance.uRes = gl.getUniformLocation(program, "uRes");
      instance.uBlobs = gl.getUniformLocation(program, "uBlobs");
      instance.wrapper.classList.add("is-oil-ready");
    }

    function resize(instance) {
      var width = instance.canvas.clientWidth;
      var height = instance.canvas.clientHeight;
      if (width === instance.width && height === instance.height) return;

      // Risoluzione contenuta: il liquido è morbido e così lo shader costa poco anche sui telefoni
      var ratio = Math.min(window.devicePixelRatio || 1, 1.5);
      instance.canvas.width = Math.round(width * ratio);
      instance.canvas.height = Math.round(height * ratio);
      instance.gl.viewport(0, 0, instance.canvas.width, instance.canvas.height);
      instance.gl.uniform2f(instance.uRes, instance.canvas.width, instance.canvas.height);
      instance.width = width;
      instance.height = height;
      instance.dirty = true;
    }

    function updateBlobs(instance, time) {
      var aspect = instance.width / instance.height;
      blobs.forEach(function (blob, index) {
        var wave = time * blob.speed + blob.phase;
        // Ingresso a cascata: ogni goccia "cade" e si gonfia con un piccolo ritardo
        var grow = clamp((instance.reveal * 1.6 - index * 0.05) / 0.6, 0, 1);
        grow = 1 - Math.pow(1 - grow, 3);
        var x;
        var y;

        if (blob.pool) {
          x = blob.x + Math.sin(wave) * 0.03;
          y = 0.87 + Math.sin(wave * 1.3) * 0.012;
        } else if (blob.orbit) {
          x = 0.5 + Math.cos(wave) * 0.34;
          y = 0.5 + Math.sin(wave * 0.8) * 0.36;
        } else {
          // Lava lamp: sale e scende lungo il proprio lato, ondeggiando un po'
          x = blob.x + Math.sin(wave * 1.7) * 0.03;
          y = 0.52 + Math.sin(wave) * 0.36;
        }

        blobData[index * 3] = x * aspect;
        blobData[index * 3 + 1] = y - (1 - grow) * 0.25;
        blobData[index * 3 + 2] = blob.r * grow * (0.92 + Math.sin(wave * 2.3) * 0.08);
      });
    }

    function render(instance, dt) {
      if (!instance.gl && !instance.failed) setup(instance);
      if (instance.failed) return;
      resize(instance);
      if (!instance.width) return;

      if (instance.reveal < 1) {
        instance.reveal = reduceMotion ? 1 : Math.min(instance.reveal + dt / 1.6, 1);
      }

      var gl = instance.gl;
      updateBlobs(instance, clock);
      gl.uniform3fv(instance.uBlobs, blobData);
      gl.clearColor(0, 0, 0, 0);
      gl.clear(gl.COLOR_BUFFER_BIT);
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
      instance.dirty = false;
    }

    function frame(now) {
      frameId = null;
      var dt = lastTime ? Math.min((now - lastTime) / 1000, 0.05) : 0;
      lastTime = now;
      if (!reduceMotion) clock += dt;

      instances.forEach(function (instance) {
        var isActive = !instance.slide || instance.slide.classList.contains("is-active");
        if (isActive && !instance.active) {
          instance.reveal = 0;
          instance.dirty = true;
        }
        instance.active = isActive;
        if (!isActive) return;
        if (reduceMotion && !instance.dirty && instance.width === instance.canvas.clientWidth && instance.reveal >= 1) return;
        render(instance, dt);
      });

      schedule();
    }

    function schedule() {
      if (frameId !== null || !heroVisible || document.hidden) return;
      frameId = window.requestAnimationFrame(frame);
    }

    if ("IntersectionObserver" in window) {
      var hero = wrappers[0].closest("[data-hero-slider]") || wrappers[0];
      new IntersectionObserver(function (entries) {
        heroVisible = entries[0].isIntersecting;
        lastTime = 0;
        schedule();
      }).observe(hero);
    }

    document.addEventListener("visibilitychange", function () {
      lastTime = 0;
      schedule();
    });

    schedule();
  }

  /*
    Olive e foglie in orbita attorno al prodotto della hero: due ellissi inclinate,
    una più bassa e stretta e una più alta e larga. La parte bassa dell'ellisse è "davanti":
    lì gli elementi passano sopra la bottiglia e si ingrandiscono, dietro rimpiccioliscono
    e vanno fuori fuoco (classe .is-back in bn-home.css).
  */
  var ORBITS = [
    { rx: 0.4, ry: 0.11, cy: 0.18, tilt: -10, speed: 0.34 },
    { rx: 0.5, ry: 0.14, cy: -0.14, tilt: 8, speed: 0.22 }
  ];

  function initOliveOrbit() {
    var wrappers = Array.prototype.slice.call(document.querySelectorAll('[data-oil-effect="orbit"], [data-oil-effect="mill"]'));
    if (!wrappers.length) return;

    var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var heroVisible = true;
    var frameId = null;
    var lastTime = 0;
    var clock = reduceMotion ? 1 : 0;

    var instances = wrappers.map(function (wrapper) {
      var image = wrapper.querySelector(".bn-media-shell__image");
      var nodes = Array.prototype.slice.call(wrapper.querySelectorAll("[data-orbit-item]"));
      if (!image || !nodes.length) return null;

      var perOrbit = Math.ceil(nodes.length / ORBITS.length);
      wrapper.classList.add("is-oil-ready");

      var dripsRoot = wrapper.querySelector("[data-orbit-drips]");

      return {
        slide: wrapper.closest("[data-hero-slider] [data-hero-slide]"),
        image: image,
        active: false,
        reveal: 0,
        drips: dripsRoot ? Array.prototype.slice.call(dripsRoot.querySelectorAll("[data-orbit-drip]")) : [],
        ripples: dripsRoot ? Array.prototype.slice.call(dripsRoot.querySelectorAll("[data-orbit-ripple]")) : [],
        nextDrip: 1.2,
        nextRipple: 0,
        items: nodes.map(function (node, index) {
          var orbitIndex = index % ORBITS.length;
          var slot = Math.floor(index / ORBITS.length);
          return {
            node: node,
            orbit: ORBITS[orbitIndex],
            angle: (slot / perOrbit) * Math.PI * 2 + orbitIndex * 0.6,
            leaf: node.getAttribute("data-orbit-item") === "leaf",
            phase: index * 1.37,
            spin: index % 2 ? 1 : -1,
            front: null,
            x: 0,
            y: 0,
            depth: 0
          };
        })
      };
    }).filter(Boolean);

    function render(instance, dt) {
      var size = instance.image.offsetHeight;
      if (!size) return;

      if (instance.reveal < 1) {
        instance.reveal = reduceMotion ? 1 : Math.min(instance.reveal + dt / 1.4, 1);
      }

      instance.items.forEach(function (item, index) {
        var orbit = item.orbit;
        // Ingresso a cascata: ogni elemento arriva da fuori e si stringe sull'orbita
        var enter = clamp((instance.reveal * 1.8 - index * 0.06) / 0.7, 0, 1);
        enter = 1 - Math.pow(1 - enter, 3);
        var spread = 1 + (1 - enter) * 0.8;

        var theta = item.angle + clock * orbit.speed;
        var depth = Math.sin(theta);
        var ex = Math.cos(theta) * orbit.rx * size * spread;
        var ey = depth * orbit.ry * size * spread;
        var tilt = (orbit.tilt * Math.PI) / 180;
        var x = ex * Math.cos(tilt) - ey * Math.sin(tilt);
        var y = ex * Math.sin(tilt) + ey * Math.cos(tilt) + orbit.cy * size + Math.sin(clock * 1.3 + item.phase) * 4;
        var scale = 0.9 + 0.4 * depth;
        var rotation = item.leaf
          ? (theta * 180) / Math.PI + item.spin * clock * 40 + item.phase * 30
          : Math.sin(clock + item.phase) * 20;

        item.node.style.transform =
          "translate(-50%, -50%) translate(" + x.toFixed(1) + "px, " + y.toFixed(1) + "px) rotate(" + rotation.toFixed(1) + "deg) scale(" + scale.toFixed(3) + ")";
        item.node.style.opacity = ((0.55 + 0.45 * (depth + 1) / 2) * enter).toFixed(3);
        item.x = x;
        item.y = y;
        item.depth = depth;

        var isFront = depth > 0;
        if (isFront !== item.front) {
          item.front = isFront;
          item.node.classList.toggle("is-front", isFront);
          item.node.classList.toggle("is-back", !isFront);
        }
      });

      if (instance.drips.length && !reduceMotion && instance.reveal >= 1) {
        instance.nextDrip -= dt;
        if (instance.nextDrip <= 0) {
          instance.nextDrip = 0.9 + Math.random() * 0.9;
          releaseDrip(instance, size);
        }
      }
    }

    /*
      Goccia d'olio: parte da un'oliva visibile che si trova sopra la vasca, cade fino alla
      pozza (alla base del prodotto, 45.5% dell'altezza sotto il centro) e la increspa.
    */
    function releaseDrip(instance, size) {
      var poolY = size * 0.455;
      var candidates = instance.items.filter(function (item) {
        return !item.leaf && item.depth > -0.4 && Math.abs(item.x) < size * 0.3 && item.y < poolY - size * 0.12;
      });
      var drip = instance.drips.filter(function (node) {
        return !node.dataset.busy;
      })[0];
      if (!candidates.length || !drip) return;

      var source = candidates[Math.floor(Math.random() * candidates.length)];
      var startY = source.y + size * 0.03;
      var x = source.x.toFixed(1);
      var duration = 700 + ((poolY - startY) / size) * 900;

      drip.dataset.busy = "1";
      drip.classList.toggle("is-front", source.depth > 0);
      drip.animate(
        [
          { transform: "translate(-50%, -30%) translate(" + x + "px, " + startY + "px) scale(0)", opacity: 0 },
          { transform: "translate(-50%, -30%) translate(" + x + "px, " + startY + "px) scale(1)", opacity: 1, offset: 0.25, easing: "cubic-bezier(0.55, 0, 1, 0.45)" },
          { transform: "translate(-50%, -30%) translate(" + x + "px, " + poolY + "px) scale(0.75, 1.4)", opacity: 1 }
        ],
        { duration: duration }
      ).onfinish = function () {
        delete drip.dataset.busy;
        var ripple = instance.ripples[instance.nextRipple];
        instance.nextRipple = (instance.nextRipple + 1) % instance.ripples.length;
        if (!ripple) return;
        ripple.animate(
          [
            { transform: "translate(-50%, -50%) translate(" + x + "px, " + poolY + "px) scale(0.05)", opacity: 0.9 },
            { transform: "translate(-50%, -50%) translate(" + x + "px, " + poolY + "px) scale(1)", opacity: 0 }
          ],
          { duration: 1400, easing: "ease-out" }
        );
      };
    }

    function frame(now) {
      frameId = null;
      var dt = lastTime ? Math.min((now - lastTime) / 1000, 0.05) : 0;
      lastTime = now;
      if (!reduceMotion) clock += dt;

      instances.forEach(function (instance) {
        var isActive = !instance.slide || instance.slide.classList.contains("is-active");
        if (isActive && !instance.active) instance.reveal = 0;
        instance.active = isActive;
        if (!isActive) return;
        if (reduceMotion && instance.reveal >= 1 && instance.drawn === instance.image.offsetHeight) return;
        render(instance, dt);
        instance.drawn = instance.image.offsetHeight;
      });

      schedule();
    }

    function schedule() {
      if (frameId !== null || !heroVisible || document.hidden) return;
      frameId = window.requestAnimationFrame(frame);
    }

    if ("IntersectionObserver" in window) {
      var hero = wrappers[0].closest("[data-hero-slider]") || wrappers[0];
      new IntersectionObserver(function (entries) {
        heroVisible = entries[0].isIntersecting;
        lastTime = 0;
        schedule();
      }).observe(hero);
    }

    document.addEventListener("visibilitychange", function () {
      lastTime = 0;
      schedule();
    });

    schedule();
  }

  onReady(function () {
    initHeroSlider();
    initOilRibbon();
    initOilLava();
    initOliveOrbit();
    initShowcaseBottleMotion();
    initLocationMapParallax();
    initLocationVideoMedia();
  });

  document.addEventListener("shopify:section:load", function (event) {
    initLocationVideoMedia(event.target);
  });
})();
